import React, { createContext, useContext, useEffect, useState } from "react";

const LikesContext = createContext(null);
const STORAGE_KEY = "msm_liked_schools";

export function LikesProvider({ children }) {
  const [slugs, setSlugs] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      const parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs));
    } catch {
      /* Storage can be unavailable in restricted browser contexts. */
    }
  }, [slugs]);

  const isLiked = (slug) => slugs.includes(slug);
  const toggleLike = (slug) => {
    setSlugs((current) =>
      current.includes(slug) ? current.filter((item) => item !== slug) : [...current, slug]
    );
  };

  return (
    <LikesContext.Provider value={{ slugs, count: slugs.length, isLiked, toggleLike }}>
      {children}
    </LikesContext.Provider>
  );
}

export function useLikes() {
  const context = useContext(LikesContext);
  if (!context) throw new Error("useLikes must be used within LikesProvider");
  return context;
}
